import React from 'react';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  LinearProgress,
  Button
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Add as AddIcon } from '@material-ui/icons';

import Dialog from '../Dialog';
import AddRecord from '../EditEventPanel/AddRecord';
import { inputFieldNames } from '../../constants';
import calculateNextEventDate from '../../mappers/calculateNextEventDate';
import { submitMode } from '../../constants';

const useStyles = makeStyles((theme) => ({
  dialog: {},
  dialogTitle: {
    background: '#f0f0f0'
  },
  dialogContent: {
    width: 580,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(3)
  },
  actionButton: {
    width: 180,
    float: 'right',
    margin: theme.spacing(2)
  },
  footer: {
    background: '#f0f0f0'
  }
}));

const AddEventRecordDialog = (props) => {
  const classes = useStyles();
  const {
    openDialog,
    onOpenAddEventRecordDialog,
    isSaving,
    record,
    onHandleInputChange,
    event,
    submitRecord,
    allAttachments,
    onRemoveAttachment,
    branchId
  } = props;

  const onDialogClose = () => {
    onOpenAddEventRecordDialog(false);
  };

  const handleSubmitRecord = (e) => {
    e.preventDefault();

    const payload = {
      eventId: event.id,
      ...record,
      nextEventDate: calculateNextEventDate(record.recordDate, event.frequency)
    };
    submitRecord(payload, submitMode.CREATE, branchId);
  };

  const handleRemoveAttachment = (attachment) => {
    onRemoveAttachment(attachment);
  };

  const handleInputChange = (e, inputfieldName) => {
    if (
      inputfieldName === inputFieldNames.LAST_HELD_DATE ||
      inputfieldName === inputFieldNames.NEXT_EVENT_DATE ||
      inputfieldName === inputFieldNames.RECORD_DATE ||
      inputfieldName === inputFieldNames.EVENT_RECORD_ATTACHMENT
    ) {
      onHandleInputChange(e, inputfieldName);
    } else {
      onHandleInputChange(e.target.value, inputfieldName);
    }
  };

  return (
    <React.Fragment>
      <Dialog
        open={openDialog}
        onClose={onDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
      >
        {isSaving ? <LinearProgress /> : ''}
        <DialogTitle id="alert-dialog-title" className={classes.dialogTitle}>
          Add Record
        </DialogTitle>
        <form onSubmit={handleSubmitRecord}>
          <DialogContent className={classes.dialogContent}>
            <AddRecord
              record={record}
              handleInputChange={handleInputChange}
              handleSubmitRecord={handleSubmitRecord}
              allAttachments={allAttachments}
              handleRemoveAttachment={handleRemoveAttachment}
            />
          </DialogContent>
          <DialogActions className={classes.footer}>
            <Button
              className={classes.actionButton}
              variant="outlined"
              onClick={onDialogClose}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              color="primary"
              className={classes.actionButton}
              variant="contained"
              startIcon={<AddIcon />}
            >
              Add
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
};

export default AddEventRecordDialog;
